import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is V

export const Voltage: BaseQuantity = {
  id: "001voltage",
  name: "voltage",
  type: "numeric",
  value: "",
  symbol: "U",
  baseUnit: "V",
  selectedUnit: "V",
  units: [{ name: "V", fromConst: 1, toConst: 1 }],
};
